import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { CDN, SMS_URL } from "../data";

const LINKS = [
  ["#services", "Services", "nav-services"],
  ["#proof", "Results", "nav-results"],
  ["#about", "About", "nav-about"],
  ["#faq", "FAQ", "nav-faq"],
  ["#request", "Request work", "nav-request"],
  ["#payments", "Invoices", "nav-invoices"],
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);
  return (
    <>
    <header className={"nav" + (scrolled || open ? " is-scrolled" : "")} data-testid="site-nav">
      <a className="brand" href="#top" aria-label="Lucho Gomez Connect, back to top" data-testid="brand-link" onClick={() => setOpen(false)}>
        <img src={CDN + "hf_20260830_192030_168afa63-aa34-4c15-a6fa-45656f723f00.png"} alt="Lucho Gomez Connect logo" width="34" height="34" />
        <span>
          <span className="brand-name">Lucho Gomez Connect</span>
          <span className="brand-sub">Property. Land. Animals. Kaua'i.</span>
        </span>
      </a>
      <nav className="nav-links" aria-label="Site">
        {LINKS.map(([href, label, tid]) => (
          <a key={href} className="nav-link" href={href} data-testid={tid}>{label}</a>
        ))}
      </nav>
      <a className="nav-cta" href={SMS_URL} data-testid="nav-estimate-cta">
        Get an estimate <span className="trail" aria-hidden="true"></span>
      </a>
      <button className="nav-burger" onClick={() => setOpen((o) => !o)} aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open} data-testid="nav-burger-btn">
        {open ? <X size={22} /> : <Menu size={22} />}
      </button>
    </header>
    <div className={"nav-drawer" + (open ? " open" : "")} data-testid="nav-drawer">
      <nav aria-label="Mobile site">
        {LINKS.map(([href, label, tid], i) => (
          <a key={href} className="drawer-link" style={{ transitionDelay: open ? `${0.06 + i * 0.05}s` : "0s" }} href={href} onClick={() => setOpen(false)} data-testid={`drawer-${tid}`}>
            <span className="drawer-num">{String(i + 1).padStart(2, "0")}</span>{label}
          </a>
        ))}
      </nav>
      <a className="drawer-cta" href={SMS_URL} onClick={() => setOpen(false)} data-testid="drawer-estimate-cta">
        Text for a free estimate
      </a>
    </div>
    </>
  );
};
